<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-main">
        <div class="footer-brand">
          <router-link to="/" class="brand-link">
            <img
              src="../../static/images/GLOBALAIlogo/GLOBALAI3.png"
              alt="Global AI Link Limited"
              class="brand-logo"
            />
            <span class="brand-name">Global AI Link Limited</span>
          </router-link>
        </div>

        <div class="footer-columns">
          <div class="footer-col">
            <h3 class="col-title">Our address</h3>
            <ul class="col-list">
              <li>
                <span class="item-label">Office Address:</span>
                RM 101A, 1/F., GENPLAS IND BUILDING, 56 HOI YUEN ROAD, KWUN
                TONG, HONG KONG
              </li>
              <li>
                <span class="item-label">Business Hours:</span>
                Monday to Friday, 09:00 – 19:00 (GMT+8, Hong Kong Time)
              </li>
              <!-- <li>
                <span class="item-label">Official Website:</span>
                <a
                  href="https://www.globalai.ink"
                  target="_blank"
                  rel="noopener noreferrer"
                  >https://www.globalai.ink</a
                >
              </li> -->
              <li>
                <span class="item-label">Tel:</span>
                <a href="tel:+85251719054">+852-51719054</a>
              </li>
              <li>
                <span class="item-label">Legal Entity:</span>
                GLOBAL AI LINK LIMITED
              </li>
            </ul>
          </div>

          <div class="footer-col">
            <h3 class="col-title">Contact Us</h3>
            <ul class="col-list">
              <li>
                <span class="item-label">Business Cooperation:</span>
                <a href="mailto:bd@globalailink.org">bd@globalailink.org</a>
              </li>
              <!-- <li>
                <span class="item-label">Media-buy Partnerships:</span>
                <a href="mailto:media-buy@globalai.ink"
                  >media-buy@globalai.ink</a
                >
              </li> -->
              <!-- <li>
                <span class="item-label">Public Relations:</span>
                <a href="mailto:PR@global.ink">PR@global.ink</a>
              </li> -->
              <li>
                <span class="item-label">Search Arbitrage Business:</span>
                <a href="mailto:bd-searcharbitrage@globalailink.org"
                  >bd-searcharbitrage@globalailink.org</a
                >
              </li>
              <li>
                <span class="item-label">Lead Generation (CPL):</span>
                <a href="mailto:bd-cpl@globalailink.org"
                  >bd-cpl@globalailink.org</a
                >
              </li>
              <li>
                <span class="item-label">Technical Support</span>
                <a href="mailto:support@globalailink.org"
                  >support@globalailink.org</a
                >
              </li>
            </ul>
          </div>

          <div class="footer-col">
            <h3 class="col-title">Need Help?</h3>
            <ul class="col-list col-list--links">
              <li>
                <button
                  type="button"
                  class="footer-link-btn"
                  @click="onSupportClick"
                >
                  Support
                </button>
              </li>
            </ul>
          </div>

          <div class="footer-col">
            <h3 class="col-title">Legal</h3>
            <ul class="col-list col-list--links">
              <li v-for="item in legalLinks" :key="item.path">
                <a
                  href="#"
                  class="footer-nav-link"
                  :class="{ 'is-active': $route.path === item.path }"
                  @click.prevent="goLegal(item.path)"
                  >{{ item.label }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-divider"></div>

      <div class="footer-bottom">
        <p>
          Copyright&copy;2025-2026 GLOBAL AI LINK LIMITED All Rights Reserved
          ,it's affiliates and licensors.
          <span class="footer-legal-links">
            <a
              href="#"
              class="footer-nav-link"
              :class="{
                'is-active': $route.path === '/legal/legal-information',
              }"
              @click.prevent="goLegal('/legal/legal-information')"
              >Legal Information</a
            >
            <span class="link-sep">|</span>
            <a
              href="#"
              class="footer-nav-link"
              :class="{ 'is-active': $route.path === '/legal/privacy-policy' }"
              @click.prevent="goLegal('/legal/privacy-policy')"
              >Privacy Policy</a
            >
            <span class="link-sep">|</span>
            <a
              href="#"
              class="footer-nav-link"
              :class="{
                'is-active': $route.path === '/legal/terms-and-policies',
              }"
              @click.prevent="goLegal('/legal/terms-and-policies')"
              >Terms &amp; Policies</a
            >
          </span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter",
  data() {
    return {
      legalLinks: [
        {
          label: "Terms and Policies",
          path: "/legal/terms-and-policies",
        },
        {
          label: "Privacy Policy",
          path: "/legal/privacy-policy",
        },
        {
          label: "Legal Information",
          path: "/legal/legal-information",
        },
      ],
    };
  },
  methods: {
    onSupportClick() {
      this.$emit("open-form");
    },
    goLegal(path) {
      const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      };

      if (this.$route.path === path) {
        scrollToTop();
        return;
      }

      this.$router.push(path).then(scrollToTop);
    },
  },
};
</script>

<style scoped>
.site-footer {
  background: #141c2b;
  color: #94a3b8;
}

.footer-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 80px 24px 32px;
}

.footer-main {
  display: flex;
  gap: 64px;
  align-items: flex-start;
}

.footer-brand {
  flex: 0 0 280px;
  margin-top: 0;
}

.brand-link {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  text-decoration: none;
  color: #ffffff;
}

.brand-logo {
  width: auto;
  height: 56px;
  object-fit: contain;
}

.brand-name {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.2px;
  line-height: 1.35;
}

.footer-columns {
  flex: 1;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 0.8fr;
  gap: 40px 32px;
}

.footer-col {
  min-width: 0;
}

.col-title {
  margin: 0 0 24px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.col-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.col-list li {
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.7;
  color: #94a3b8;
}

.col-list li:last-child {
  margin-bottom: 0;
}

.item-label {
  display: block;
  color: #cbd5e1;
  font-weight: 500;
  margin-bottom: 4px;
  font-size: 13px;
}

.col-list a,
.col-list--links a,
.footer-nav-link {
  color: #94a3b8;
  text-decoration: none;
  transition: color 0.25s ease;
}

.col-list a:hover,
.col-list--links a:hover,
.col-list--links a.router-link-active,
.footer-nav-link:hover,
.footer-nav-link.is-active {
  color: #60a5fa;
}

.col-list--links li {
  margin-bottom: 12px;
}

.footer-link-btn {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 14px;
  line-height: 1.7;
  color: #94a3b8;
  cursor: pointer;
  text-align: left;
  transition: color 0.25s ease;
}

.footer-link-btn:hover {
  color: #60a5fa;
}

.footer-divider {
  margin: 56px 0 24px;
  height: 1px;
  background: rgba(148, 163, 184, 0.15);
}

.footer-bottom {
  text-align: center;
}

.footer-bottom p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  line-height: 1.6;
}

.footer-legal-links {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-left: 8px;
}

.footer-legal-links a,
.footer-legal-links .footer-nav-link {
  color: #94a3b8;
  text-decoration: none;
  transition: color 0.25s ease;
}

.footer-legal-links a:hover,
.footer-legal-links a.router-link-active,
.footer-legal-links .footer-nav-link:hover,
.footer-legal-links .footer-nav-link.is-active {
  color: #60a5fa;
}

.link-sep {
  margin: 0 6px;
  color: #64748b;
}

@media (max-width: 1100px) {
  .footer-columns {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .footer-inner {
    padding: 48px 20px 24px;
  }

  .footer-main {
    flex-direction: column;
    gap: 40px;
  }

  .footer-brand {
    flex: none;
  }

  .brand-link {
    flex-direction: row;
    align-items: center;
  }

  .footer-columns {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .footer-divider {
    margin: 40px 0 24px;
  }
  
  .footer-legal-links {
    display: flex;
    margin-left: 0;
    margin-top: 8px;
  }
  
  .link-sep {
    display: none;
  }
}
</style>
